import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { toasterConfig } from 'shared/toaster/toaster-config';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';

import Bugsnag from '@bugsnag/js';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppRoutingService } from './app-routing.service';

import { LoginModule } from './login/login.module';
import { ResetPasswordModule } from './reset-password/reset-password.module';
import { ForgotPasswordModule } from './forgot-password/forgot-password.module';
import { AcceptInviteModule } from './accept-invite/accept-invite.module';
import { SharedModule } from 'shared/shared.module';

// pages
import { MyProductsModule } from './my-products/my-products.module';
import { DigitalAssetsModule } from './digital-assets/digital-assets.module';
import { DigitalAssetDetailsModule } from './digital-asset-details/digital-asset-details.module';
import { ProductDetailsModule } from './product-details/product-details.module';
import { ProductDetailsV2Module } from './product-details-v2/product-details.module';
import { ProductPanelModule } from './product-panel/product-panel.module';
import { GlobalPagesModule } from './global-pages/global-pages.module';
import { DigitalAssetsPanelModule } from './digital-assets-panel/digital-assets-panel.module';
import { EcommerceModule } from './ecommerce/ecommerce.module';
import { MyFitmentsModule } from './my-fitments/my-fitments.module';
import { WelcomeModule } from './welcome/welcome.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { ExportManagerModule } from './export-manager/export-manager.module';
import { ImportManagerModule } from './import-manager/import-manager.module';
import { AccountSetupModule } from './account-setup/account-setup.module';
import { ReportsModule } from './reports/reports.module';
import { GetStartedModule } from './get-started/get-started.module';
import { ReceiversModule } from './receivers/receivers.module';

import { Config } from 'shared/config/env.config';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

if (Config.BUGSNAG_KEY) {
  Bugsnag.start({
    apiKey: Config.BUGSNAG_KEY,
    appVersion: Config.VERSION,
  });
}

export function errorHandlerFactory() {
  return Config.BUGSNAG_KEY ? new BugsnagErrorHandler() : new ErrorHandler();
}


export function tokenGetter() {
  return localStorage.getItem(Config.AUTH_TOKEN);
}


export function jwtOptionsFactory() {
  return {
    tokenGetter: tokenGetter,
    allowedDomains: [new RegExp('localhost|rxspeed.com|speedquo.com|partshub.com|127.0.0.1')],
  };
}


@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(toasterConfig),
    HttpClientModule,
    AppRoutingModule,
    LoginModule,
    ResetPasswordModule,
    ForgotPasswordModule,
    AcceptInviteModule,
    MyProductsModule,
    DigitalAssetsModule,
    DigitalAssetDetailsModule,
    ProductDetailsModule,
    ProductPanelModule,
    GlobalPagesModule,
    DigitalAssetsPanelModule,
    EcommerceModule,
    MyFitmentsModule,
    WelcomeModule,
    DashboardModule,
    ExportManagerModule,
    ImportManagerModule,
    AccountSetupModule,
    ProductDetailsV2Module,
    ReportsModule,
    GetStartedModule,
    ReceiversModule,
    SharedModule.forRoot(),
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
      }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  declarations: [AppComponent],
  providers: [
    AppRoutingService,
    { provide: ErrorHandler, useFactory: errorHandlerFactory }
  ],
  bootstrap: [AppComponent]

})
export class AppModule { }
